import React, { Component } from 'react';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { getNewses } from '../actions/NewsAction';
import { l10n } from '../i18n/Localization';
import DatumCard from './DatumCard';
import NewsesListCard from './NewsesListCard';

class IndexPage extends Component {
  componentDidMount() {
    if (this.props.newses.length === 0) {
      this.props.getNewses();
    }
  }

  render() {
    const { authCompleted, user } = this.props.authState;
    const { initializeResult } = this.props.appState;
    const { newses } = this.props;

    const characterCount = (initializeResult !== null) ? initializeResult.characterCount : 0;

    let content;
    if (user) {
      content = (
        <div className="container mt-3">
          <div className="row">
            <div className="col-12 col-md-9 order-2 order-md-1">
              <div className="row">
                <div className="col-12 col-md-6 col-lg-4 mb-3" key="characterCount">
                  <DatumCard name={l10n.indexPage.characters} value={characterCount} url={'/characters/'} />
                </div>
              </div>
            </div>
            <div className="col-12 col-md-3 order-1 order-md-2 mb-3">
              <NewsesListCard newses={newses} />
            </div>
          </div>
        </div>
      );
    } else {
      content = (
        <div className="container mt-3">
          <div className="text-center mb-3">
            <img src={`${process.env.PUBLIC_URL}/icon_foreground.png`} width="128" alt="icon"></img>
          </div>
          <h1 className="text-center">{l10n.indexPage.hintWelcome}</h1>
          <div style={{ height: "5rem" }}>
            <div id="carousel" className="carousel slide" data-ride="carousel">
              <div className="carousel-inner">
                <div className="carousel-item active">
                  <h5 className="text-center">{l10n.productSlogan}</h5>
                </div>
                <div className="carousel-item">
                  <h5 className="text-center">{l10n.hint.feature0}</h5>
                </div>
                <div className="carousel-item">
                  <h5 className="text-center">{l10n.hint.feature1}</h5>
                </div>
              </div>
            </div>
          </div>
          <p className="text-center">{l10n.indexPage.hintSignIn}</p>
          <div className="d-flex justify-content-center mb-3">
            {authCompleted ? (<Link className="btn btn-success" to="/sign-in">{l10n.auth.signIn}</Link>) : null}
          </div>
          <p className="text-center">{l10n.indexPage.hintSignUp}</p>
          <div className="d-flex justify-content-center">
            {authCompleted ? (<Link className="btn btn-outline-success" to="/sign-up">{l10n.auth.signUp}</Link>) : null}
          </div>
        </div>
      );
    }

    return (
      <div className="IndexPage">
        <Helmet>
          <link rel="icon" type="image/x-icon" href={`${process.env.PUBLIC_URL}/favicon.ico`} />
          <meta name="description" content={l10n.productName + ', ' + l10n.productSlogan} />
          <title>{l10n.productName} - {l10n.productSlogan}</title>
        </Helmet>
        {content}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    appState: { ...state.appState },
    authState: { ...state.authState },
    newses: state.newsState.newses,
  }
};

const mapDispatchToProps = (dispatch) => {
  return {
    getNewses: () => {
      dispatch(getNewses());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(IndexPage);
